export const useMapQueryParams = ({ location }) => {
  const params = new URLSearchParams(location?.search);
  let center = undefined;
  let zoom = undefined;

  if (params.has('map_center')) {
    center = params
      .get('map_center')
      .split(',')
      .map(Number)
      .reduce((acc, curr, index) => {
        if (index === 0) {
          acc.lat = curr;
        } else if (index === 1) {
          acc.lng = curr;
        }
        return acc;
      }, {});
  }

  if (params.has('map_zoom_level')) {
    zoom = parseFloat(params.get('map_zoom_level'));
  }

  return {
    mapCenter: center,
    mapZoom: zoom
  };
};
